<template>
  <div id="HandsontableButtonAdd">
    <el-button class="el-button eb-button-red eb-button-small" @click="addRow">添加条目</el-button>
  </div>
</template>
<script>
import eventBus from '@/plugins/event-bus';
export default {
  name: 'HandsontableButtonAdd',
  props: ['eventBusEventName'],
  methods: {
    addRow: function() {
      eventBus.$emit(this.eventBusEventName);
    }
  }
};
</script>
<style>

</style>
